import React from "react";
import { Modal, Switch } from "antd";
import { ModalProps } from "antd/es/modal";
import style from "./index.module.scss";

interface SwitchRenderProps extends ModalProps {
    onCancel: () => void;
    onSave: () => void;
    isProcess: boolean; //过程化考核
    isVisible: boolean; //学生是否可见
    setIsProcess: (val: BooleanValue) => void;
    setVisible: (val: BooleanValue) => void;
}

const Index = ({
    onSave,
    onCancel,
    isProcess,
    isVisible,
    setVisible,
    setIsProcess,
    ...props
}: SwitchRenderProps) => {
    return (
        <Modal
            width={420}
            className={style.root}
            closable={false}
            centered
            onCancel={onCancel}
            onOk={onSave}
            {...props}>
            <div className={style.item}>
                将本课程的成绩规则作为过程化考核规则：
                <Switch
                    size="small"
                    defaultChecked={isProcess}
                    onChange={e => setIsProcess(e ? "1" : "0")}
                    className={style.switchBtn}
                />
            </div>
            <div className={style.item}>
                允许学生查看规则：
                <Switch
                    size="small"
                    defaultChecked={isVisible}
                    onChange={e => setVisible(e ? "1" : "0")}
                    className={style.switchBtn}
                />
            </div>
        </Modal>
    );
};

export default Index;
